import { StatesModule } from '@uirouter/angular';

import { ViewportComponent } from './viewport/viewport.component';
import { ScreenSharingComponent } from './components/screen-sharing/screen-sharing.component';
import { ModeratorJoinComponent } from './components/moderator-join/moderator-join.component';
import { ModeratorRoomComponent } from './components/moderator-room/moderator-room.component';
import { ScreenSharingService } from './services/screen-sharing.service';

export const routes: StatesModule = {
  states: [

    {
      name: 'apps.screen-sharing',
      abstract: true,
      component: ViewportComponent,
      resolve: [
        {
          token: 'screenSharing',
          deps: [ScreenSharingService],
          resolveFn: (screenSharingService) => screenSharingService.clearErrors()
        }
      ]
    },
    {
      name: 'apps.screen-sharing.home',
      url: '/join?rvshare&joinCode&memberDisplayName',
      component: ScreenSharingComponent,
      data: {
        rvshareAppEnabled: true,
        requiresAuth: false
      },
    },
    {
      name: 'apps.screen-sharing.moderator-join',
      url: '/screen-sharing/join?rvshare',
      component: ModeratorJoinComponent,
      data: {
        rvshareAppEnabled: true,
        requiresAuth: false
      },
      resolve: [
        {
          token: 'canAccess',
          deps: ['canAccessApps', 'urlStateService'],
          resolveFn: (canAccessApps, urlStateService) => {
            const redirectTo = urlStateService.urlToState('/screen-sharing/join');
            return canAccessApps(undefined, undefined, redirectTo);
          }
        }
      ]
    },
    {
      name: 'apps.screen-sharing.moderator-room',
      url: '/screen-sharing/room/:displayId/?rvshare',
      component: ModeratorRoomComponent,
      data: {
        rvshareAppEnabled: true,
      }
    }
  ]
};
